import type { School, Address } from "@/types/models";

export interface SchoolRecommendation extends Omit<School, "address"> {
  address?: Pick<Address, "address1" | "city" | "state" | "zip_code">;
}

export type SchoolRecommendationResponse = SchoolRecommendation[];

export const schoolRecommendationMock: SchoolRecommendationResponse = [
  {
    id: 49,
    pk: 49,
    date_created: "2015-10-22T12:50:30-05:00",
    date_modified: "2024-05-02T15:15:44.436736-05:00",
    unique_id: "38331f3f77294e579dd10a40d4eb4006",
    name: "OASIS School",
    school_type: "PU",
    nces_district_id: null,
    nces_school_id: null,
    notes: "Internal school for Newsela staff",
    data_source: "IMPORT",
    google_places_id: null,
    is_valid: true,
    agile_institution_id: null,
    is_demo: false,
    website: null,
    address: {
      address1: "10 Mos Eisley Drive",
      city: "New York",
      state: "NY",
      zip_code: "10001",
    },
    groups: [],
  },
  {
    id: 2000257848,
    pk: 2000257848,
    date_created: "2023-03-24T13:20:32.712588-05:00",
    date_modified: "2024-05-02T15:12:54.972868-05:00",
    unique_id: "8a961bc96d544615a18642cc11961438",
    name: "Newsela Technology School",
    school_type: "PU",
    nces_district_id: null,
    nces_school_id: null,
    notes: "Created by: 2020455394",
    data_source: "Django Admin",
    google_places_id: null,
    is_valid: true,
    agile_institution_id: null,
    is_demo: false,
    website: null,
    address: {
      address1: "10 Mos Eisley Drive",
      city: "New York",
      state: "NY",
      zip_code: "10001",
    },
    groups: [],
  },
];
